module.exports = __webpack_public_path__ + "img/205.tables.6174a580.svg";